module.exports = __webpack_public_path__ + "img/banner02-1.e56a1668.jpg";